// INICIO ARK MODA - Configuracion popup caja especial
// Cambia ACTIVO a false cuando no quieras mostrar el popup.
// Para pruebas, deja USAR_FECHAS en false.
const ARK_CAJA_POPUP_ACTIVO = false;
const ARK_CAJA_POPUP_USAR_FECHAS = false;
const ARK_CAJA_POPUP_FECHA_INICIO = '2026-05-01';
const ARK_CAJA_POPUP_FECHA_FIN = '2026-05-15';
const ARK_CAJA_VARIANT_ID = '45547052794047';
const ARK_CAJA_PRECIO_TEXTO = '$13.000';
const ARK_CAJA_IMAGEN_URL = '//arkmoda.com/cdn/shop/files/CAJAPREMIUMDESCRIPCION.jpg?v=1777001517&width=1200';

// Nivel PRO: evita ser invasivo y permite excluir productos puntuales.
// Si quieres que el popup salga cada vez durante pruebas, cambia ARK_CAJA_POPUP_UNA_VEZ_SESION a false.
const ARK_CAJA_POPUP_UNA_VEZ_SESION = true;
const ARK_CAJA_POPUP_SESSION_KEY = 'ark_caja_popup_mostrado_v1';

// Si algún producto NO debe mostrar popup, agrega su handle aquí. Ejemplo: ['caja', 'tarjeta-regalo']
const ARK_CAJA_POPUP_EXCLUIR_HANDLES = ['caja'];

// INICIO ARK MODA - Configuracion dinamica desde bloque Shopify
// Si agregas el bloque "Popup caja premium Ark Moda" en el editor del tema,
// estos valores se leen desde main-product.liquid. Si el bloque no existe,
// se mantiene la configuracion fija anterior como respaldo seguro.
// FIN ARK MODA - Configuracion dinamica desde bloque Shopify
// FIN ARK MODA - Configuracion popup caja especial

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // INICIO ARK MODA - Mostrar popup antes de agregar al carrito
        const arkConfigCaja = this.arkCajaPopupConfig();
        const arkVariantPrincipal = String(this.variantIdInput?.value || '');
        const arkPopupDisponible =
          this.arkCajaPopupDisponible() &&
          arkVariantPrincipal !== String(arkConfigCaja.variantId) &&
          !this.arkProductoExcluidoDelPopup();

        if (arkPopupDisponible && !this.dataset.arkCajaDecision) {
          const arkYaTieneCaja = await this.arkYaTieneCajaEnCarrito();
          const arkYaSeMostroEnSesion =
            arkConfigCaja.unaVezSesion && sessionStorage.getItem(arkConfigCaja.sessionKey) === '1';

          if (!arkYaSeMostroEnSesion) {
  this.arkMostrarPopupCaja();
  return;
}
        }
        // FIN ARK MODA - Mostrar popup antes de agregar al carrito

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const arkAgregarCaja = this.dataset.arkCajaDecision === 'yes';

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        // INICIO ARK MODA - Si acepta, agregar producto principal + caja especial en una sola peticion
        if (arkAgregarCaja) {
          const arkCantidadPrincipal = Number(formData.get('quantity') || 1);
          const arkSections = this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : [];

          config.headers['Content-Type'] = 'application/json';
          config.body = JSON.stringify({
            items: [
              { id: Number(formData.get('id')), quantity: arkCantidadPrincipal > 0 ? arkCantidadPrincipal : 1 },
              { id: Number(this.arkCajaPopupConfig().variantId), quantity: arkCantidadPrincipal > 0 ? arkCantidadPrincipal : 1 },
            ],
            sections: arkSections,
            sections_url: window.location.pathname,
          });
        } else {
          config.body = formData;
        }
        // FIN ARK MODA - Si acepta, agregar producto principal + caja especial en una sola peticion

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            // INICIO ARK MODA - Permitir volver a mostrar el popup sin refrescar
            // Después de agregar al carrito (con caja o sin caja), limpiamos la decisión temporal
            // para que un nuevo clic en "Añadir al carrito" pueda evaluar nuevamente el popup.
            delete this.dataset.arkCajaDecision;
            // FIN ARK MODA - Permitir volver a mostrar el popup sin refrescar

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      // INICIO ARK MODA - Funciones popup caja especial
      arkCerrarCarritoAntesPopup() {
        const cartDrawer = document.querySelector('cart-drawer');
        const cartNotification = document.querySelector('cart-notification');

        // Si Dawn abrió el carrito lateral vacío antes del popup, lo cerramos/ocultamos
        // para que el cliente se concentre solo en la oferta de la caja.
        if (cartDrawer) {
          if (typeof cartDrawer.close === 'function') {
            cartDrawer.close();
          }

          cartDrawer.classList.remove('active');
          cartDrawer.classList.remove('animate');
          cartDrawer.removeAttribute('open');
          cartDrawer.setAttribute('aria-hidden', 'true');
        }

        if (cartNotification && typeof cartNotification.close === 'function') {
          cartNotification.close();
        }

        document.body.classList.remove('overflow-hidden');
        document.body.classList.remove('overflow-hidden-tablet');
        document.body.classList.remove('overflow-hidden-mobile');
      }

      arkCajaPopupConfig() {
        const configEl = document.querySelector('[data-ark-caja-popup-config]');
        const dataset = configEl?.dataset || {};

        return {
          activo: dataset.activo === 'true' || (!configEl && ARK_CAJA_POPUP_ACTIVO),
          usarFechas: dataset.usarFechas === 'true' || (!configEl && ARK_CAJA_POPUP_USAR_FECHAS),
          fechaInicio: dataset.fechaInicio || ARK_CAJA_POPUP_FECHA_INICIO,
          fechaFin: dataset.fechaFin || ARK_CAJA_POPUP_FECHA_FIN,
          variantId: dataset.variantId || ARK_CAJA_VARIANT_ID,
          precioTexto: dataset.precioTexto || ARK_CAJA_PRECIO_TEXTO,
          precioCentavos: Number(dataset.precioCentavos || 0),
          imagenUrl: dataset.imagenUrl || ARK_CAJA_IMAGEN_URL,
          unaVezSesion: dataset.unaVezSesion === 'true' || (!configEl && ARK_CAJA_POPUP_UNA_VEZ_SESION),
          sessionKey: dataset.sessionKey || ARK_CAJA_POPUP_SESSION_KEY,
          aplicaColeccion: dataset.aplicaColeccion !== 'false',
          coleccionesSeleccionadas: (dataset.coleccionesSeleccionadas || '')
            .split(',')
            .map((id) => id.trim())
            .filter(Boolean),
          coleccionesSeleccionadasHandles: (dataset.coleccionesSeleccionadasHandles || '')
            .split(',')
            .map((handle) => handle.trim())
            .filter(Boolean),
          coleccionesProductoIds: (dataset.coleccionesProductoIds || '')
            .split(',')
            .map((id) => id.trim())
            .filter(Boolean),
          coleccionesProducto: (dataset.coleccionesProducto || '')
            .split(',')
            .map((handle) => handle.trim())
            .filter(Boolean),
          productoExcluido: dataset.productoExcluido === 'true',
          tagTexto: dataset.tagTexto || '🎁 Opción de regalo',
          tituloSingular: dataset.tituloSingular || '¿Añadir caja premium?',
          tituloPlural: dataset.tituloPlural || '¿Añadir cajas premium?',
          textoSingular: dataset.textoSingular || 'Se añadirá 1 caja especial para mejorar la presentación de tu pedido.',
          textoPlural: dataset.textoPlural || 'Seleccionaste [cantidad] unidades. Se añadirán [cantidad] cajas, una para cada producto.',
          botonNo: dataset.botonNo || 'No',
          excluirHandles: (dataset.excluirHandles || ARK_CAJA_POPUP_EXCLUIR_HANDLES.join(','))
            .split(',')
            .map((handle) => handle.trim())
            .filter(Boolean),
        };
      }

      arkProductoExcluidoDelPopup() {
        const config = this.arkCajaPopupConfig();
        const pathParts = window.location.pathname.split('/').filter(Boolean);
        const handle = pathParts[pathParts.length - 1] || '';
        return config.excluirHandles.includes(handle);
      }

      async arkYaTieneCajaEnCarrito() {
        try {
          const config = this.arkCajaPopupConfig();
          const response = await fetch('/cart.js', { credentials: 'same-origin' });
          const cart = await response.json();
          return Array.isArray(cart.items) && cart.items.some((item) => String(item.id) === String(config.variantId));
        } catch (error) {
          console.warn('ARK MODA: no se pudo validar si la caja ya estaba en carrito.', error);
          return false;
        }
      }

      arkCajaPopupDisponible() {
        const config = this.arkCajaPopupConfig();

        if (!config.activo) return false;

        // ARK MODA - Regla PRO por colecciones:
        // - Sin colecciones seleccionadas: aplica a todos los productos de esta plantilla.
        // - Con colecciones seleccionadas: aplica solo si el producto pertenece a una de ellas.
        if (config.coleccionesSeleccionadas.length > 0 || config.coleccionesSeleccionadasHandles.length > 0) {
          const coincidePorId = config.coleccionesProductoIds.some((id) =>
            config.coleccionesSeleccionadas.includes(id)
          );
          const coincidePorHandle = config.coleccionesProducto.some((handle) =>
            config.coleccionesSeleccionadasHandles.includes(handle)
          );

          if (!coincidePorId && !coincidePorHandle) return false;
        } else if (!config.aplicaColeccion) {
          return false;
        }

        if (config.productoExcluido) return false;
        if (!config.variantId) return false;
        if (!config.usarFechas) return true;

        const hoy = new Date();
        const inicio = new Date(config.fechaInicio + 'T00:00:00');
        const fin = new Date(config.fechaFin + 'T23:59:59');

        return hoy >= inicio && hoy <= fin;
      }

      arkMostrarPopupCaja() {
        this.arkCerrarCarritoAntesPopup();
        document.body.classList.add('ark-caja-popup-open');
        const arkConfigCaja = this.arkCajaPopupConfig();

        // INICIO ARK MODA - Texto dinamico segun cantidad seleccionada
        const arkCantidadSeleccionada = Number(new FormData(this.form).get('quantity') || 1);
        const arkCantidadCajas = arkCantidadSeleccionada > 0 ? arkCantidadSeleccionada : 1;
        const arkPrecioUnitarioCaja =
          arkConfigCaja.usarPrecioAutomatico && arkConfigCaja.precioCentavos > 0
            ? Math.round(arkConfigCaja.precioCentavos / 100)
            : Number(String(arkConfigCaja.precioTexto).replace(/[^0-9]/g, '')) || 13000;
        const arkPrecioTotalCaja = arkPrecioUnitarioCaja * arkCantidadCajas;
        const arkPrecioTotalTexto = '$' + new Intl.NumberFormat('es-CO').format(arkPrecioTotalCaja);

        const arkPopupTitulo =
          arkCantidadCajas > 1 ? arkConfigCaja.tituloPlural : arkConfigCaja.tituloSingular;

        const arkPopupTexto =
          arkCantidadCajas > 1
            ? arkConfigCaja.textoPlural.replaceAll('[cantidad]', String(arkCantidadCajas))
            : arkConfigCaja.textoSingular;

        const arkPopupPrecioLabel =
          arkCantidadCajas > 1 ? `Precio adicional (${arkCantidadCajas} cajas)` : 'Precio adicional';

       const arkPopupBotonSi =
  arkCantidadCajas > 1
    ? `Añadir ${arkCantidadCajas} cajas`
    : `Si, Añadir 1 caja`;
        // FIN ARK MODA - Texto dinamico segun cantidad seleccionada

        let modal = document.querySelector('#ark-caja-popup');

        if (!modal) {
          modal = document.createElement('div');
          modal.id = 'ark-caja-popup';
          modal.className = 'ark-caja-popup';
          modal.innerHTML = `
            <div class="ark-caja-popup__overlay" aria-hidden="true"></div>
            <div class="ark-caja-popup__box" role="dialog" aria-modal="true" aria-labelledby="ark-caja-popup-title">
              <button type="button" class="ark-caja-popup__close" aria-label="Cerrar">×</button>

              <div class="ark-caja-popup__image-wrap">
                <img src="${arkConfigCaja.imagenUrl}" alt="Caja premium Ark Moda" class="ark-caja-popup__image">
              </div>

              <div class="ark-caja-popup__content">
                <span class="ark-caja-popup__tag">${arkConfigCaja.tagTexto}</span>
                <h2 id="ark-caja-popup-title">${arkPopupTitulo}</h2>
                <p class="ark-caja-popup__text">${arkPopupTexto}</p>

                <div class="ark-caja-popup__price-line">
                  <span class="ark-caja-popup__price-label">${arkPopupPrecioLabel}</span>
                  <strong class="ark-caja-popup__price-total">${arkPrecioTotalTexto}</strong>
                </div>

                <div class="ark-caja-popup__actions">
                  <button type="button" class="button button--primary ark-caja-popup__yes">${arkPopupBotonSi}</button>
                  <button type="button" class="button button--secondary ark-caja-popup__no">${arkConfigCaja.botonNo}</button>
                </div>
              </div>
            </div>
          `;
          document.body.appendChild(modal);
          this.arkInsertarEstilosCajaPopup();
        }

        // INICIO ARK MODA - Actualizar textos si el popup ya existia en el DOM
        const modalTitle = modal.querySelector('#ark-caja-popup-title');
        const modalText = modal.querySelector('.ark-caja-popup__text');
        const modalPriceLabel = modal.querySelector('.ark-caja-popup__price-label') || modal.querySelector('.ark-caja-popup__price-line span');
        const modalPriceTotal = modal.querySelector('.ark-caja-popup__price-total') || modal.querySelector('.ark-caja-popup__price-line strong');
        const modalYesButton = modal.querySelector('.ark-caja-popup__yes');
        const modalNoButton = modal.querySelector('.ark-caja-popup__no');
        const modalTag = modal.querySelector('.ark-caja-popup__tag');
        const modalImage = modal.querySelector('.ark-caja-popup__image');

        if (modalImage && arkConfigCaja.imagenUrl) modalImage.setAttribute('src', arkConfigCaja.imagenUrl);
        if (modalTitle) modalTitle.textContent = arkPopupTitulo;
        if (modalText) modalText.textContent = arkPopupTexto;
        if (modalPriceLabel) modalPriceLabel.textContent = arkPopupPrecioLabel;
        if (modalPriceTotal) modalPriceTotal.textContent = arkPrecioTotalTexto;
        if (modalYesButton) modalYesButton.textContent = arkPopupBotonSi;
        if (modalNoButton) modalNoButton.textContent = arkConfigCaja.botonNo;
        if (modalTag) modalTag.textContent = arkConfigCaja.tagTexto;
        // FIN ARK MODA - Actualizar textos si el popup ya existia en el DOM

        const closeModal = () => {
          modal.classList.remove('ark-caja-popup--active');
          document.body.classList.remove('ark-caja-popup-open');

          // INICIO ARK MODA - Limpiar decisión temporal al cerrar popup
          // Evita que un cierre accidental deje bloqueada la opción hasta refrescar página.
          delete this.dataset.arkCajaDecision;
          // FIN ARK MODA - Limpiar decisión temporal al cerrar popup
        };

        const submitAgain = (addCaja) => {
          closeModal();
          this.dataset.arkCajaDecision = addCaja ? 'yes' : 'no';
          this.form.requestSubmit();
        };

        modal.querySelector('.ark-caja-popup__close').onclick = () => submitAgain(false);
        modal.querySelector('.ark-caja-popup__overlay').onclick = () => submitAgain(false);
        modal.querySelector('.ark-caja-popup__no').onclick = () => submitAgain(false);
        modal.querySelector('.ark-caja-popup__yes').onclick = () => submitAgain(true);

        // INICIO ARK MODA - Guardar sesión solo si el bloque lo tiene activado
        if (arkConfigCaja.unaVezSesion) {
          sessionStorage.setItem(arkConfigCaja.sessionKey, '1');
        }
        // FIN ARK MODA - Guardar sesión solo si el bloque lo tiene activado
        modal.classList.add('ark-caja-popup--active');
        document.body.classList.add('ark-caja-popup-open');
      }

      arkInsertarEstilosCajaPopup() {
        if (document.querySelector('#ark-caja-popup-styles')) return;

        const styles = document.createElement('style');
        styles.id = 'ark-caja-popup-styles';
        styles.textContent = `
          .ark-caja-popup{display:none;position:fixed;z-index:2147483000;inset:0;font-family:var(--font-body-family,inherit)}body.ark-caja-popup-open cart-drawer,body.ark-caja-popup-open .cart-drawer,body.ark-caja-popup-open #CartDrawer,body.ark-caja-popup-open cart-notification,body.ark-caja-popup-open .cart-notification{display:none!important;visibility:hidden!important;pointer-events:none!important;opacity:0!important}.ark-caja-popup--active{display:flex;align-items:center;justify-content:center;padding:18px}.ark-caja-popup__overlay{position:absolute;inset:0;background:rgba(12,12,12,.56);backdrop-filter:blur(3px);-webkit-backdrop-filter:blur(3px)}.ark-caja-popup__box{position:relative;z-index:1;width:min(92vw,420px);max-height:calc(100dvh - 36px);overflow:auto;background:#fff;border-radius:26px;text-align:center;box-shadow:0 24px 70px rgba(0,0,0,.28);animation:arkCajaPopIn .2s ease-out}.ark-caja-popup__close{position:absolute;right:12px;top:12px;width:38px;height:38px;border:0;border-radius:999px;background:#fff;color:#111;font-size:30px;line-height:1;cursor:pointer;z-index:3;box-shadow:0 8px 24px rgba(0,0,0,.12)}.ark-caja-popup__image-wrap{padding:22px 18px 8px;background:linear-gradient(180deg,#fafafa,#fff)}.ark-caja-popup__image{display:block;width:min(330px,78vw);max-width:100%;height:auto;margin:0 auto;object-fit:contain;filter:drop-shadow(0 14px 22px rgba(0,0,0,.10))}.ark-caja-popup__content{padding:6px 26px 26px}.ark-caja-popup__tag{display:inline-flex;align-items:center;justify-content:center;margin-bottom:10px;padding:6px 12px;border-radius:999px;background:#f5f5f5;color:#222;font-size:12px;font-weight:700;letter-spacing:.02em}.ark-caja-popup__box h2{margin:0 auto 9px;max-width:340px;font-size:27px;line-height:1.12;letter-spacing:.01em;color:#111}.ark-caja-popup__text{margin:0 auto 16px;max-width:340px;font-size:15.5px;line-height:1.45;color:#555}.ark-caja-popup__price-line{display:flex;align-items:center;justify-content:space-between;gap:12px;margin:0 0 18px;padding:13px 15px;border-radius:16px;background:#f8f8f8;border:1px solid rgba(0,0,0,.07);font-size:14px;color:#666}.ark-caja-popup__price-line strong{font-size:22px;line-height:1;color:#111}.ark-caja-popup__actions{display:grid;gap:10px}.ark-caja-popup__actions .button{width:100%;min-height:52px;border-radius:999px;font-size:15.5px;font-weight:700;letter-spacing:.01em}.ark-caja-popup__yes{background:#bfe4fb!important;color:#111!important}.ark-caja-popup__no{background:#fff!important;color:#111!important;border:1.5px solid #111!important}body.ark-caja-popup-open{overflow:hidden!important}@keyframes arkCajaPopIn{from{opacity:0;transform:translateY(10px) scale(.985)}to{opacity:1;transform:translateY(0) scale(1)}}@media screen and (max-width:749px){.ark-caja-popup{align-items:flex-end;padding:10px}.ark-caja-popup__box{width:100%;border-radius:24px;max-height:calc(100dvh - 20px)}.ark-caja-popup__image-wrap{padding:16px 12px 6px}.ark-caja-popup__image{width:min(340px,82vw);max-width:100%;object-fit:contain}.ark-caja-popup__content{padding:6px 18px 20px}.ark-caja-popup__tag{font-size:11.5px;margin-bottom:8px}.ark-caja-popup__box h2{font-size:24px}.ark-caja-popup__text{font-size:14.5px;margin-bottom:13px}.ark-caja-popup__price-line{padding:11px 13px;margin-bottom:14px}.ark-caja-popup__price-line strong{font-size:20px}.ark-caja-popup__actions .button{min-height:50px;font-size:15px}.ark-caja-popup__close{right:10px;top:10px;width:36px;height:36px}}@media screen and (max-width:380px){.ark-caja-popup__image{width:min(310px,82vw);max-width:100%;object-fit:contain}.ark-caja-popup__box h2{font-size:22px}.ark-caja-popup__content{padding-left:14px;padding-right:14px}}
        `;
        document.head.appendChild(styles);
      }
      // FIN ARK MODA - Funciones popup caja especial

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

// INICIO ARK MODA - Sticky add to cart propio conectado al formulario principal
(function () {
  'use strict';

  function arkInitStickyAddToCart() {
    var sticky = document.querySelector('[data-ark-sticky-atc]');
    if (!sticky || sticky.dataset.arkStickyReady === 'true') return;

    var productInfo = document.querySelector('product-info');
    var mainProductForm = document.querySelector('product-info product-form');
    var mainForm = document.querySelector('product-info product-form form[data-type="add-to-cart-form"]');
    var mainSubmit = document.querySelector('product-info product-form [type="submit"][name="add"]');
    var stickyButton = sticky.querySelector('[data-ark-sticky-atc-trigger]');
    var stickyText = sticky.querySelector('[data-ark-sticky-atc-text]');
    var stickyPrice = sticky.querySelector('[data-ark-sticky-price]');
    var priceSource = document.querySelector('[id^="price-"]');

    if (!productInfo || !mainProductForm || !mainForm || !mainSubmit || !stickyButton) return;

    sticky.dataset.arkStickyReady = 'true';

    function arkSyncStickyButton() {
      var mainSpan = mainSubmit.querySelector('span');
      var isDisabled =
        mainSubmit.disabled ||
        mainSubmit.getAttribute('aria-disabled') === 'true' ||
        mainSubmit.classList.contains('loading');

      stickyButton.disabled = isDisabled;

      if (stickyText && mainSpan && mainSpan.textContent.trim()) {
        stickyText.textContent = mainSpan.textContent.trim();
      }

      if (mainSubmit.classList.contains('loading')) {
        stickyButton.classList.add('is-loading');
      } else {
        stickyButton.classList.remove('is-loading');
      }
    }

    function arkSyncStickyPrice() {
      if (!stickyPrice || !priceSource) return;

      var stickyCurrentPrice = stickyPrice.querySelector('[data-ark-sticky-current-price]');
      var stickyComparePrice = stickyPrice.querySelector('[data-ark-sticky-compare-price]');

      var salePrice =
        priceSource.querySelector('.price__sale .price-item--sale') ||
        priceSource.querySelector('.price-item--sale');

      var regularPrice =
        priceSource.querySelector('.price__regular .price-item--regular') ||
        priceSource.querySelector('.price-item--regular');

      var comparePrice =
        priceSource.querySelector('.price__sale .price-item--regular') ||
        priceSource.querySelector('s.price-item--regular') ||
        priceSource.querySelector('.price__sale s .price-item');

      var visibleCurrentPrice = salePrice || regularPrice;
      var visibleComparePrice = comparePrice;

      if (stickyCurrentPrice && visibleCurrentPrice && visibleCurrentPrice.textContent.trim()) {
        stickyCurrentPrice.textContent = visibleCurrentPrice.textContent.trim();
      } else if (visibleCurrentPrice && visibleCurrentPrice.textContent.trim()) {
        stickyPrice.textContent = visibleCurrentPrice.textContent.trim();
        return;
      }

      if (stickyComparePrice) {
        if (
          visibleComparePrice &&
          visibleComparePrice.textContent.trim() &&
          visibleCurrentPrice &&
          visibleComparePrice.textContent.trim() !== visibleCurrentPrice.textContent.trim()
        ) {
          stickyComparePrice.textContent = visibleComparePrice.textContent.trim();
          stickyComparePrice.hidden = false;
        } else {
          stickyComparePrice.hidden = true;
        }
      }
    }

    stickyButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      arkSyncStickyButton();

      if (stickyButton.disabled) return;

      /*
        ARK MODA:
        No agregamos al carrito desde este sticky.
        Hacemos click real sobre el botón principal para que se ejecuten también
        listeners externos del tema/snippets, incluyendo el upsell Ark, y luego
        el mismo submit original dispara popup caja premium, validaciones y cart drawer.
      */
      if (typeof mainSubmit.click === 'function') {
        mainSubmit.click();
      } else if (typeof mainForm.requestSubmit === 'function') {
        mainForm.requestSubmit();
      } else {
        mainForm.submit();
      }
    });

    var arkMainButtonVisible = false;
    var arkVisibilityTicking = false;

    function arkIsMobileStickyView() {
      return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    }

    function arkMainButtonIsVisibleFallback() {
      if (!mainSubmit || !mainSubmit.getBoundingClientRect) return false;

      var rect = mainSubmit.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;

      return (
        rect.width > 0 &&
        rect.height > 0 &&
        rect.bottom > 0 &&
        rect.right > 0 &&
        rect.top < viewportHeight &&
        rect.left < viewportWidth
      );
    }

    function arkUpdateStickyVisibility() {
      arkVisibilityTicking = false;

      var isMobile = arkIsMobileStickyView();
      var scrollTrigger = isMobile ? 70 : 150;
      var hasScrolledEnough = window.scrollY > scrollTrigger;
      var mainButtonVisible = arkMainButtonVisible || arkMainButtonIsVisibleFallback();
      var blockingLayerOpen =
        document.body.classList.contains('ark-caja-popup-open') ||
        document.body.classList.contains('overflow-hidden') ||
        document.body.classList.contains('overflow-hidden-mobile') ||
        document.body.classList.contains('overflow-hidden-tablet');

      /*
        ARK MODA - comportamiento PRO:
        - No duplicar CTA cuando el botón principal está visible.
        - En móvil aparece pronto al bajar, porque el botón se pierde rápido.
        - En desktop/tablet aparece al salir del área de compra y se mantiene en contenido largo.
        - Nunca se muestra encima del popup ni de drawers/modales.
      */
      var shouldShow = hasScrolledEnough && !mainButtonVisible && !blockingLayerOpen;

      sticky.hidden = !shouldShow;
      sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      document.body.classList.toggle('ark-sticky-atc-visible', shouldShow);
      arkSyncStickyButton();
      arkSyncStickyPrice();
    }

    function arkRequestStickyVisibilityUpdate() {
      if (arkVisibilityTicking) return;
      arkVisibilityTicking = true;
      window.requestAnimationFrame(arkUpdateStickyVisibility);
    }

    if ('IntersectionObserver' in window) {
      var arkButtonObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          arkMainButtonVisible = entry.isIntersecting && entry.intersectionRatio > 0.12;
        });
        arkRequestStickyVisibilityUpdate();
      }, {
        root: null,
        threshold: [0, 0.12, 0.35, 0.65, 1],
        rootMargin: '0px 0px -8px 0px'
      });

      arkButtonObserver.observe(mainSubmit);
    } else {
      arkMainButtonVisible = arkMainButtonIsVisibleFallback();
    }

    window.addEventListener('scroll', arkRequestStickyVisibilityUpdate, { passive: true });

    var buttonMutationObserver = new MutationObserver(arkRequestStickyVisibilityUpdate);
    buttonMutationObserver.observe(mainSubmit, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class'],
      childList: true,
      subtree: true
    });

    if (priceSource) {
      var priceMutationObserver = new MutationObserver(arkSyncStickyPrice);
      priceMutationObserver.observe(priceSource, { childList: true, subtree: true, characterData: true });
    }

    document.addEventListener('change', function (event) {
      if (event.target && event.target.closest('product-info')) {
        window.setTimeout(function () {
          arkSyncStickyButton();
          arkSyncStickyPrice();
        }, 80);
      }
    });

    document.addEventListener('variant:change', function () {
      window.setTimeout(function () {
        arkSyncStickyButton();
        arkSyncStickyPrice();
      }, 80);
    });

    window.addEventListener('resize', arkRequestStickyVisibilityUpdate, { passive: true });
    window.addEventListener('orientationchange', arkRequestStickyVisibilityUpdate, { passive: true });
    window.addEventListener('pageshow', arkRequestStickyVisibilityUpdate);

    arkSyncStickyButton();
    arkSyncStickyPrice();
    arkRequestStickyVisibilityUpdate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arkInitStickyAddToCart);
  } else {
    arkInitStickyAddToCart();
  }

  document.addEventListener('shopify:section:load', arkInitStickyAddToCart);
})();
// FIN ARK MODA - Sticky add to cart propio conectado al formulario principal

